module.exports = __webpack_public_path__ + "static/media/people_services.6d0cab66.jpg";